import { StylesDerivedNativeActionNames } from '@wix/editor-platform-host-integration-apis';
import { CompRef } from '@wix/document-services-types';
import { EditorPointer } from '@wix/editorx-core-api';
import { ALLOWED_CSS_PROPERTY_TYPES_BY_ACTION_NAME } from '../../../../apis/services/editActionsServices/nativeActions/globalDesign/constants';
import { GlobalDesignPanelProps, GlobalDesignStyleGroup } from '../../types';

export const compareValuesPair = <
  TActionName extends StylesDerivedNativeActionNames,
>(
  cssPropertyType: (typeof ALLOWED_CSS_PROPERTY_TYPES_BY_ACTION_NAME)[TActionName][number],
  value1: unknown,
  value2: unknown,
  config: MergingStrategyConfig<TActionName>,
) => {
  return config.valueComparator[cssPropertyType](value1, value2);
};

export type Comparator<TActionName extends StylesDerivedNativeActionNames> = {
  [K in (typeof ALLOWED_CSS_PROPERTY_TYPES_BY_ACTION_NAME)[TActionName][number]]: (
    value1: any,
    value2: any,
  ) => boolean;
};

export type GroupingStrategy = () => Promise<GlobalDesignStyleGroup[]>;

export type MergingStrategyConfig<
  TActionName extends StylesDerivedNativeActionNames,
> = {
  valueComparator: Comparator<TActionName>;
  propertyTypesToIgnore?: (typeof ALLOWED_CSS_PROPERTY_TYPES_BY_ACTION_NAME)[TActionName][number][]; // TODO make propper type without optional
  allowSubsets: boolean;
};
